<template>
  <div class="mm-row-block" v-loading="loading">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
      <div class="form-isheader-group">
        <div class="group-title">
          <h3>基本資料</h3>
        </div>
        <div class="form-isheader-group-content">
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="舊會員編號">
                <el-input v-model="form.old_customer_num" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="電話號碼" prop="phone">
                <el-input v-model="form.phone" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="會員名稱" prop="name">
                <el-input v-model="form.name">
                  <el-button slot="append" @click="form.name=sify(form.name)" clearable>繁轉簡</el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="英文名稱" prop="ename">
                <el-input clearable v-model="form.ename" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="稱謂" prop="appellations">
                <el-select class="elselect" v-model="form.appellations" clearable placeholder="請選擇" :popper-append-to-body="false">
                  <el-option :label="'先生'" :value="1"></el-option>
                  <el-option :label="'女士'" :value="2"></el-option>
                  <el-option :label="'小姐'" :value="3"></el-option>
                  <el-option :label="'太太'" :value="4"></el-option>
                  <el-option :label="'其他'" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="國籍" prop="country_id">
                <el-input v-model="form.country_id" v-show="false"></el-input>
                <countryselect :form="form"></countryselect>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="身份證或護照" prop="card">
                <el-input v-model="form.card" clearable></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="住址" prop="address">
                <el-input v-model="form.address" clearable>
                  <el-button slot="append" @click="form.address=sify(form.address)">繁轉簡</el-button>
                </el-input>
              </el-form-item>
            </div>
          </div>
          <div class="mm-row ">
            <div class="mm-col flex50">
              <el-form-item label="代理" prop="agent">
                <div style="margin:10px 0">
                  <el-switch style="display: block" v-model="form.agent" active-color="#13ce66" inactive-color="#ff4949" active-text="是" inactive-text="否" active-value="1" inactive-value="0">
                  </el-switch>
                </div>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>

      <div class="form-isheader-group">
        <div class="group-title">
          <h3>會員文件</h3>
        </div>
        <div class="form-isheader-group-content">
          <uploadimage :fileDir="'customer'" :imageUrlList.sync="form.customer_upload_list" listType="picture-card"></uploadimage>
        </div>
      </div>
      <div class="form-isheader-group">
        <div class="group-title">
          <h3 class="mr15">審查結果 Name Screening Result</h3>
          <div class="shengchabon" v-if="examineStatus()">
            <el-input-number class="mr15 pcshow2" v-model="form.shengchascore" :min="0" :max="100" label="審查起始分數"></el-input-number>
            <el-button @click="examine" type="primary" plain>在線审查</el-button>
          </div>
        </div>
        <div class="form-isheader-group-content">
          <div style="margin-bottom: 20px;">
            <div class="group-sub-title">
              <h3>OFAC</h3>
            </div>
            <el-table empty-text="暫無數據" :data="form.examinedata" border :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column label="Name" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Name</div>
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Address" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Address</div>
                  <span>{{scope.row.address}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Type" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Type</div>
                  <span>{{scope.row.type}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Program(s)" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Program(s)</div>
                  <span>{{scope.row.program}}</span>
                </template>
              </el-table-column>
              <el-table-column label="List" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">List</div>
                  <span>{{scope.row.list}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Score" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Score</div>
                  <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                  <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                  <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Url" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Url</div>
                  <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                </template>
              </el-table-column>
              <el-table-column label="Query Time" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Query Time</div>
                  <span>{{scope.row.addtime}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-bottom: 20px;">
            <div class="group-sub-title">
              <h3>UNSC</h3>
            </div>
            <el-table empty-text="暫無數據" :data="form.examinedataxml" border :header-cell-style="{background:'#FAFAFA'}">
              <el-table-column label="Name" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Name</div>
                  <span>{{scope.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Type" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">type</div>
                  <span>{{scope.row.type}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Design" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">design</div>
                  <span>{{scope.row.design}}</span>
                </template>
              </el-table-column>

              <el-table-column label="Date" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">date</div>
                  <span>{{scope.row.date}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Score" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Score</div>
                  <span style="color:red" v-if="scope.row.score>90">{{scope.row.score}}</span>
                  <span v-if="scope.row.score<=90 && scope.row.score>0">{{scope.row.score}}</span>
                  <span style="color:green" v-if="scope.row.score==0">{{scope.row.score}}</span>
                </template>
              </el-table-column>
              <el-table-column label="Url" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">url</div>
                  <span v-if="scope.row.url"><a :href="scope.row.url" target="_blank">{{scope.row.url}}</a></span>
                </template>
              </el-table-column>
              <el-table-column label="Query Time" align="center">
                <template slot-scope="scope">
                  <div class="phonecel">Query Time</div>
                  <span>{{scope.row.addtime}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="margin-bottom: 20px;" v-if="examineStatus()">
            <el-image style="width: 148px; height: 148px" :src="form.examineimg" :preview-src-list="form.examineimglist">
            </el-image>
          </div>
          <uploadimage :fileDir="'customer'" :imageUrlList.sync="form.review_upload_list" listType="picture-card"></uploadimage>
        </div>
      </div>
      <div class="form-submit">
        <el-button type="primary" @click="formsubmit('form')">保存</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
import countryselect from "@/components/CountrySelect.vue";
import uploadimage from "@/components/Uploadimage.vue";
export default {
  components: {
    countryselect,
    uploadimage
  },
  name: "person",
  data () {
    return {
      loading:false,
      showpicurl: '',
      showpicbox: false,
      value1: 0,
      ordertype: -1,
      form: {
        card:'',
        address:'',
        mso_id: 0,
        type: 0,
        country_id: '',
        review_upload_list: [],
        customer_upload_list: [],
        shengchascore:95,
        examineimg: '',
        examineimglist: [],
        examinedata: [],
        examineimgpath: '',
        examinedataxml: [],
      },
      rules: {
        phone: [{
          required: true,
          message: '請輸入電話號碼',
        },
        ],
        name: [{
          required: true,
          message: '請輸入會員名稱',
        }
        ],
        appellations: [{
          required: true,
          message: '請選擇稱爲',
        }
        ],
        country_id: [{
          required: true,
          message: '請選擇會員國籍/地區',
        }, {
          pattern: /^[1-9]\d*$/,
          message: '請選擇會員國籍/地區'
        },
        ],
        email: [
          {
            type: 'email',
            message: '請輸入正確的郵箱地址',
            trigger: 'blur'
          }
        ]



      }
    }
  },
  methods: {
    examine () {
      let ename = this.form.ename;
      let country_id = this.form.country_id;
      if (!ename) {
        this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 請填寫審查英文姓名</div>', '提示', {
          dangerouslyUseHTMLString: true
        });
        return false;
      }
      let card = this.form.card;
      // 企業或行家時
      if (this.form.type != 0) {
        card = this.form.company_card;
      }
      let address = this.form.address;
      let score = this.form.shengchascore;
      this.loading = true;
      this.form.examineimg = '';
      this.form.examineimglist = [];
      this.post('api/order/examine', {
        ename,
        country_id,
        card,
        address,
        score
      })
        .then(res => {
          this.loading = false;
          if (res.status == 'error') {
            this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請嘗試添加國籍，身份證，地址信息</div>', '提示', {
              dangerouslyUseHTMLString: true
            });
            return false;
          } else if (res.status == 'success') {
            this.form.examinedataxml = res.examinedataxml;
            this.form.examinedata = res.data;
            this.form.examineimg = res.thumburl;
            this.form.examineimgpath = res.thumburl2;
            this.form.examineimglist.push(res.thumburl);
          }

        }).catch(error => {
          this.loading = false;
          this.$alert('<div class="alertbox"><i class="alert-error el-icon-error"></i> 查詢失敗，請求超時</div>', '提示', {
            dangerouslyUseHTMLString: true
          });
          return false;
        });

    },
    pageback () {
      this.$router.go(-1);
    },
    formsubmit (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let data = this.form;
          this.loading = true;
          this.post('/api/customer/customer_add',
            data
          ).then((res) => {
            if (res.status == 'success') {
              this.$message({
                showClose: true,
                message: '添加會員成功！',
                type: 'success',
                onClose: (() => {
                })
              });
              this.pageback();
            } else if (res.status == 'phone_exist') {
              this.$message({
                showClose: true,
                message: '對不起，該手機號碼已 註冊，會員編號為：' + res.data.customer_num,
                type: 'error',
              });
            } else {
              this.$message({
                showClose: true,
                message: '添加會員失敗，請重試！',
                type: 'error',

              });
            }

            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err)
          });
        } else {
          this.$message({
            showClose: true,
            message: '請填寫用戶信息，戶主名稱，電話號碼等必填字段后提交！',
            type: 'error',

          });
        }
      });
    },
  },
  created () {
    this.form.mso_id = sessionStorage.getItem('mso_id');
  }
}
</script>

<style scoped>
.flex50 {
  flex: 0 50%;
}
</style>
